import {Select} from "antd";
import React from "react";
import {TableOutlined} from "@ant-design/icons";

const {Option} = Select;

export const TablesSelect = ({tables, onSelect, selectedTable}) => {

    if (!tables || tables.length === 0) {
        return <div style={{textAlign: 'center', padding: '20px'}}>No tables available</div>;
    }

    return <Select style={{width: '100%'}} value={selectedTable} onChange={onSelect}>
        {tables.map(item => <Option key={item.tableName} value={item.tableName}><TableOutlined /> {item.tableName}</Option>)}
    </Select>


    // <Select
    //     mode="multiple"
    //     disabled
    //     style={{ width: '100%' }}
    //     placeholder="Please select"
    //     defaultValue={['a10', 'c12']}
    //     onChange={handleChange}
    //     options={options}
    // />
}